import Cookie from 'react-cookies'

//Defaults imports
import * as Config from "../config/const";


export const getLanguage = () => {
    let language
    if ((language = Cookie.load(Config.hash.cookie_lang)) === undefined || (language = Cookie.load(Config.hash.cookie_lang)) === 'undefined' || (language = Cookie.load(Config.hash.cookie_lang)) === null) {
        Cookie.save(Config.hash.cookie_lang, Config.defaults.default_lang)
        return Config.defaults.default_lang;
    }
    return language
}

export const setLanguage = (lang) => {
    Cookie.save(Config.hash.cookie_lang, lang)
    window.location.reload();
}


// WEBPACK FOOTER //
// ./src/actions/commands.js